import React from 'react';

/**
 * LearningSummary - Displays learning statistics (activities completed, streak, XP)
 */
export const LearningSummary = ({ stats, t, formatNumber }) => {
  return (
    <div className="card border rounded-3 mb-4">
      <div className="card-body p-4">
        <h3 className="h6 fw-bold mb-4">{t('curriculum.learning_summary.title')}</h3>

        {/* Activities Completed */}
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex align-items-center gap-2">
              <div
                className="bg-success-subtle rounded-2 d-flex align-items-center justify-content-center"
                style={{ width: '32px', height: '32px' }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" fill="#198754" viewBox="0 0 448 512">
                  <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                </svg>
              </div>
              <span className="text-muted small">{t('curriculum.learning_summary.activities_completed')}</span>
            </div>
            <span className="fw-bold fs-5">{formatNumber(stats.completed_sessions_count)}</span>
          </div>
        </div>

        {/* Current Streak */}
        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex align-items-center gap-2">
              <div
                className="bg-warning-subtle rounded-2 d-flex align-items-center justify-content-center"
                style={{ width: '32px', height: '32px' }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" fill="#fd7e14" viewBox="0 0 448 512">
                  <path d="M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"/>
                </svg>
              </div>
              <span className="text-muted small">{t('curriculum.learning_summary.current_streak')}</span>
            </div>
            <span className="fw-bold fs-5">{stats.current_streak} {t('curriculum.learning_summary.days')}</span>
          </div>
        </div>

        {/* Total XP */}
        <div>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex align-items-center gap-2">
              <div
                className="bg-primary-subtle rounded-2 d-flex align-items-center justify-content-center"
                style={{ width: '32px', height: '32px' }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#6f42c1" viewBox="0 0 576 512">
                  <path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/>
                </svg>
              </div>
              <span className="text-muted small">{t('curriculum.learning_summary.total_xp')}</span>
            </div>
            <span className="fw-bold fs-5" data-testid="total-xp">{formatNumber(stats.total_xp)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearningSummary;
